import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" clip-path=\"url(#a)\"><path stroke-width=\"1.882\" d=\"M10.43 16.416v-1.18c0-1.304-1.083-2.36-2.42-2.36H3.165c-1.337 0-2.421 1.056-2.421 2.36v1.18M5.588 10.515c1.337 0 2.421-1.057 2.421-2.36 0-1.304-1.084-2.361-2.421-2.361-1.338 0-2.422 1.057-2.422 2.36 0 1.304 1.084 2.36 2.422 2.36\"></path><path stroke-width=\"1.6\" d=\"M13.412 9.587c2.057 0 3.725-1.698 3.725-3.793S15.469 2 13.411 2 9.687 3.698 9.687 5.794s1.668 3.793 3.726 3.793\"></path><path stroke-width=\"1.6\" d=\"M13.412 4.276v1.707l1.49.57\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h18v18H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }